import React, { Fragment } from 'react';
import { Button, Form } from 'react-bootstrap';
import Loader from '../Main/Loader';
import useMyAccount from '../../Hooks/MyProfile/useMyAccount';
import AppButton from '../Main/Button';
import { PasswordInput } from '../Main/Inputs';

const MyProfileScreen = () => {
    const [
        isEdit,
        setIsEdit,
        email,
        isloading,
        firstName,
        lastName,
        phone,
        oldPassword,
        newPassword,
        confirmNewPassword,
        handleFirstName,
        handleLastName,
        handlePhone,
        handleOldpass,
        handleNewpass,
        handleConfirmNewpass,
        handleSubmit,
        handleChangePass
    ] = useMyAccount();

    return (
        <Fragment >
            <h5 className='fw-600 border-bottom pb-3'>My Profile</h5>

            {isEdit === "" && (
                <>
                    <Form onSubmit={(e) => e.preventDefault()} className='row'>
                        <h5 className='s-16'>Personal Information</h5>
                        <Form.Group className="mb-3 col-lg-6">
                            <Form.Control
                                type="text"
                                className='border-0'
                                placeholder="First Name"
                                value={firstName}
                                disabled={!isEdit}

                            />
                        </Form.Group>
                        <Form.Group className="mb-3 col-lg-6">
                            <Form.Control
                                type="text"
                                className='border-0'
                                placeholder="Last Name"
                                value={lastName}
                                disabled={!isEdit}

                            />
                        </Form.Group>
                        <Form.Group className="mb-3 col-lg-6">
                            <Form.Control
                                type="text"
                                className='border-0'
                                placeholder="Email"
                                value={email}
                                disabled={!isEdit}

                            />
                        </Form.Group>
                        <Form.Group className="mb-3 col-lg-6">
                            <Form.Control
                                type="number"
                                className='border-0'
                                placeholder="Phone"
                                value={phone}
                                disabled={!isEdit}
                            />
                        </Form.Group>

                        <div>
                            <button
                                type="button"
                                className='mb-3 btn btn-danger px-4 py-2'
                                onClick={() => setIsEdit("personalInformation")}
                            >
                                Edit Info
                            </button>
                        </div>
                    </Form >


                    <hr />
                    <Form onSubmit={(e) => e.preventDefault()} className='row'>
                        <h5 className='s-16'>Security</h5>
                        <Form.Group className="mb-3">
                            <Form.Control disabled type="password" className='border-0' placeholder="Password" />
                        </Form.Group>

                        <div>
                            <button
                                type="button"

                                className='mb-3 btn btn-danger px-4 py-2'
                                onClick={() => setIsEdit("security")}
                            >
                                Change Password
                            </button>
                        </div>
                    </Form>
                </>
            )}

            {isEdit === "personalInformation" &&
                (
                    <>
                        <Form onSubmit={handleSubmit} className='row'>
                            <h5 className='s-16'>Personal Information</h5>
                            <Form.Group className="mb-3 col-lg-6">
                                <Form.Control
                                    type="text"
                                    className='border-0'
                                    placeholder="First Name"
                                    value={firstName}
                                    onChange={handleFirstName}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3 col-lg-6">
                                <Form.Control
                                    type="text"
                                    className='border-0'
                                    placeholder="Last Name"
                                    value={lastName}
                                    onChange={handleLastName}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3 col-lg-12">
                                <Form.Control
                                    type="text"
                                    className='border-0'
                                    placeholder="Phone"
                                    value={phone}
                                    onChange={handlePhone}
                                />
                            </Form.Group>

                            <div>

                                <AppButton
                                    type={"submit"}
                                    isloading={isloading}
                                    title={"Save Changes"}
                                />
                            </div>
                        </Form>
                    </>
                )
            }

            {isEdit === "security" &&
                (
                    <>



                        <Form onSubmit={handleChangePass} className='row'>
                            <h5 className='s-16'>Security</h5>

                            <div className="col-12">

                                <PasswordInput
                                    placeholder="Old Password"
                                    value={oldPassword}
                                    handleChange={handleOldpass}
                                />
                            </div>
                            <div className="col-12">

                                <PasswordInput
                                    placeholder="New Password"
                                    value={newPassword}
                                    handleChange={handleNewpass}
                                />
                            </div>
                            <div className="col-12">

                                <PasswordInput
                                    placeholder="Confirm New Password"
                                    value={confirmNewPassword}
                                    handleChange={handleConfirmNewpass}
                                />
                            </div>

                            <div>

                                <Button
                                    type="submit"
                                    className='mb-3 btn btn-danger px-4 py-2'
                                >
                                    {
                                        isloading ? <Loader /> : "Save Changes"
                                    }

                                </Button>
                            </div>
                        </Form>
                    </>
                )
            }


        </Fragment >
    )
}

export default MyProfileScreen;
